// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__GLz12","content":"styles_content__QCOCR","stickyMobileCTA":"styles_stickyMobileCTA__9F_NU"};